import { render, staticRenderFns } from "./PayrollCompaniesComponent.vue?vue&type=template&id=1ec62433&scoped=true&"
import script from "./PayrollCompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./PayrollCompaniesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec62433",
  null
  
)

export default component.exports